export default class rekaiautocomplete {
  constructor(element) {
    this.inputElement = element.querySelector("input[type=search]");
    if (!this.inputElement) return;

    this.waitForRekai(() => {
      window.__rekai.ready(() => {
        const override = window.__rekai_predict_url_override;
        let baseUrl;
        if (override) {
          const sep = override.indexOf("?") === -1 ? "?" : "&";
          baseUrl = override + sep + "term=";
        } else {
          const rekai = window.__rekai;
          const customer = JSON.parse(JSON.stringify(rekai.customer));
          const sendObj = rekai.buildSendObject(customer, {}, true, { isLink: false }, []);
          const params = rekai.getPredictionURLParameters({}, sendObj, customer);
          baseUrl = rekai.predictUrl + params + "&rt=flat&keywords=true&term=";
        }

        window
          .rekai_autocomplete(this.inputElement, {}, [
            {
              source: (query, callback) => {
                fetch(baseUrl + encodeURIComponent(query))
                  .then((r) => r.json())
                  .then((data) => {
                    callback(Array.isArray(data) ? data : []);
                  })
                  .catch((err) => {
                    console.error("rekai autocomplete fetch failed:", err);
                    callback([]);
                  });
              },
              templates: {
                suggestion: (suggestion) => {
                  return (
                    '<div class="rekai-suggestion-item" style="padding: 8px 12px; cursor: pointer;">' +
                    '<span style="display: block; font-weight: 600;">' + suggestion.title + "</span>" +
                    '<span style="display: block; font-size: 0.85em; color: #888; margin-top: 2px;">' + suggestion.url + "</span>" +
                    "</div>"
                  );
                },
              },
            },
          ])
          .on("rekai_autocomplete:selected", (event, suggestion) => {
            if (suggestion && suggestion.url) {
              window.location.href = suggestion.url;
            }
          });
      });
    });
  }

  waitForRekai(callback) {
    if (typeof window.__rekai !== "undefined") {
      callback();
      return;
    }
    const observer = new MutationObserver((mutations, obs) => {
      if (typeof window.__rekai !== "undefined") {
        obs.disconnect();
        clearTimeout(timeout);
        callback();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    const timeout = setTimeout(() => {
      observer.disconnect();
      console.error("rekai: script did not load within 30s");
    }, 30000);
  }
}
